import React from 'react';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import Chip from 'material-ui/Chip';

const styles = {
  card:{
    margin:8,
  },
  cardheader:{
    padding:8,
    paddingBottom:0,
  },
  maintext:{
    paddingTop:0,
    paddingBottom:5,
  },
  chip: {
    margin: 4,
    backgroundColor:"rgb(240,240,240)"
  },
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
};

export default class ExperienceSkogen extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  handleExpandChange = (expanded) => {
    this.setState({expanded: expanded});
  };

  handleToggle = (event, toggle) => {
    this.setState({expanded: toggle});
  };

  handleExpand = () => {
    this.setState({expanded: true});
  };

  handleReduce = () => {
    this.setState({expanded: false});
  };

  render() {
    return (
      <Card
        expanded={this.state.expanded}
        onExpandChange={this.handleExpandChange}
        style={styles.card}
      >
        <CardHeader
          title="Skogen Engineering Group, Assistant Engineer"
          subtitle="Accident Reconstruction: 2004-2010, Madison, WI"
          avatar="images/skogen.jpg"
          actAsExpander={true}
          showExpandableButton={this.props.showCarrot}
          style={styles.cardheader}
        />
        <CardText
          style={styles.maintext}
        >
          <div>
            <ul>
              <li>
                Data gathering, preservation, and analysis for vehicle accident reconstruction (
                  <a href="http://www.skogen.com" target="_blank" rel="noopener noreferrer">
                    www.skogen.com
                  </a>
                )
              </li>
              <div style={styles.wrapper}>
                <Chip style={styles.chip}>
                  AutoCAD
                </Chip>
                <Chip style={styles.chip}>
                  Bosch Crash Data Retrieval (CDR)
                </Chip>
              </div>
            </ul>
          </div>
        </CardText>
        <CardText expandable={true}>
          <ul>
            <li>
              Mathematical modeling using conservation of energy and momentum
            </li>
            <li>
              Sokkia Total Station surveying
            </li>
            <li>
              HVE EdCrash
            </li>
            <li>
              PC-Crash 2D
            </li>
            <li>
              Photomodeler Photogrammetry
            </li>
          </ul>
        </CardText>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ExperienceSkogen.js